import React from "react";
import { useNavigate } from "react-router-dom";
import "./admintabel.css";
import Underline from "../../../pages/dashboard/Underline";

const AdminTabelHeader = ({ title, btnname, path, btnStatus = true }) => {
  const navigate = useNavigate();

  const toggleFullScreen = () => {
    if (!document.fullscreenElement &&  // Check if the page is not in fullscreen
      !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
      // Enter Fullscreen for modern browsers
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) { // Firefox
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari, Opera
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
        document.documentElement.msRequestFullscreen();
      }
    } else {
      // Exit Fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { // Chrome, Safari, Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen();
      }
    }
  };
  return (
    <div className="w-full z-50">
      <div className="flex justify-between items-center  px-4 py-2 ">
        <div>
          <h2 className="text-2xl font-bold first-letter:text-4xl first-letter:font-extrabold first-letter:text-forging-yellow">
            {title}
          </h2>

          
          <Underline />
        </div>

        {btnStatus && (
          <button onClick={() => navigate(path)} type="button" class="button">
            <div class="button-top">{btnname}</div>
            <div class="button-bottom"></div>
            <div class="button-base"></div>
          </button>
        )}
      </div>
    </div>
  );
};

export default AdminTabelHeader;
